import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit, QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ChatService} from 'app/services/chat.service';
import {Subscription} from 'rxjs';
import {ChatScrollbarComponent} from 'app/components/ui/chat/chat-scrollbar/item';
import {Message} from '../../../../../../chat-sdk/src/entities/messages/message';
import {CaseMetadata} from '../../../../../../chat-sdk/src/entities/caseMetadata';
import {Group} from '../../../../../../chat-sdk/src/entities/groups/group';
import {AppService} from '../../../../services/app.service';
import {ChatHeightDirective} from '../../../../core/directives/chatHeight.directive';
import {ChatInputFieldComponent} from '../chat-input-field/item';
import {HelperService} from '../../../../services/helper.service';
import {ChatObserverDirective} from "../chat-observer/chat-observer.directive";

@Component({
  selector: 'app-chat-wrapper',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatWrapperComponent implements OnInit, OnDestroy {
  protected readonly HelperService = HelperService;

  @Input() groupId: string = null;
  @Input() caseMetadata: CaseMetadata = null;

  @ViewChild(ChatHeightDirective) chatHeight: ChatHeightDirective;
  @ViewChild(ChatScrollbarComponent) scrollbar: ChatScrollbarComponent;
  @ViewChildren(ChatObserverDirective) observer: QueryList<ChatObserverDirective>;

  public group: Group;
  public showFixedChatInput = false;

  isShowScrollToBottom = false;
  scrollbarOnStart = false;
  loading = true;
  groupCreateState = false;
  isGroupSelected = false;
  isChatOpened = false;

  appService: AppService;
  chatService: ChatService;
  cdr: ChangeDetectorRef;

  public keyboardModal: HTMLIonModalElement = null;
  public keyboardModalComponent: ChatInputFieldComponent = null;

  public loadingString;

  private _chatGroupChangedSub: Subscription;

  constructor(
    appService: AppService,
    chatService: ChatService,
    cdr: ChangeDetectorRef
  ) {
    // @todo redo for injection
    this.appService = appService;
    this.chatService = chatService;
    this.cdr = cdr;
  }

  ngOnInit() {
    // @todo chat add subscript for chat ready
    if (this.findGroup()) {
      this.selectGroup();
    } else {
      if (this.isChatOpened) {
        this.keyboardModalComponent.form.enable();
      }
      this.isGroupSelected = true;
      this.subscribeToChatChange();
    }

  }

  subscribeToChatChange() {
    this._chatGroupChangedSub?.unsubscribe();
    this._chatGroupChangedSub = this.chatService.onGroupChange.subscribe(() => {
      if (this.findGroup()) {
        this.selectGroup();
      }
    });
  }

  findGroup() {
    if (this.chatService.chat.groups.length) {
      if (this.groupId) {
        this.group = this.chatService.chat.groups.getById(this.groupId);
      } else if (this.caseMetadata) {
        this.group = this.chatService.chat.groups.getByCase(this.caseMetadata);
      }
    }

    this.cdr.detectChanges();
    return !!this.group;
  }

  createGroup() {
    this._chatGroupChangedSub?.unsubscribe();

    return new Promise<void>((resolve, reject) => {
      // const content: Partial<GroupContent> = {
      //   title: 'Test group',
      //   description: 'Test group for some TMC, to talk about, chill and other stuff',
      //   tags: [
      //     {
      //       title: 'ТМЦ',
      //       slug: 'tmc'
      //     }
      //   ]
      // };
      //
      // const users1 = new GroupUser();
      // users1.user = {id: 410, workerId: 1248};
      // users1.public = {title: 'Для теста', titleColor: 'secondary'};
      // users1.permissions = ['readMessages', 'postMessages', 'editGroup', 'editSelfMessages', 'editUser'];
      //
      // const users2 = new GroupUser();
      // users2.user = {id: 409, workerId: 1488};
      // users2.public = {title: 'Для теста', titleColor: 'secondary'};
      // users2.permissions = ['readMessages', 'postMessages', 'editGroup', 'editSelfMessages', 'editUser'];
      //
      // const users3 = new GroupUser();
      // users3.user = {id: 408, workerId: 1496};
      // users3.permissions = ['readMessages', 'postMessages', 'editGroup', 'editSelfMessages', 'editUser'];
      // users3.public = {title: 'Для теста', titleColor: 'secondary'};

      // this.chatService.chat.createGroupFromData(content, [users1, users2, users3]).then(() => {
      //
      //   console.log('createGroup finish');
      //   resolve();
      // }).catch((error) => {
      //   this.appService.showAlert('Error', error.toString(), true);
      //
      //   this.subscribeToChatChange();
      //   reject();
      // });

      this.chatService.chat.createGroupFromCase(this.caseMetadata).then(() => {
        resolve();
      }).catch((error) => {
        this.appService.showAlert('Error', error.toString(), true);

        this.subscribeToChatChange();
        reject();
      });
    });
  }

  selectGroup() {
    return new Promise<void>((resolve, reject) => {
      if (this.group && this.group.selected === false) {

        this._chatGroupChangedSub?.unsubscribe();

        this.group.select(true).then(() => {
          this.cdr.detectChanges();

          this.group.registerOnGroupUpdate((type) => {
            if (type.includes('delete')) {
              this.group = null;
              this.subscribeToChatChange();
            }

            this.cdr.detectChanges();
          });

          this.group.registerOnMessagesUpdate((items) => {
            setTimeout(() => {
              items.some(item => {
                if (item.type.includes('create') && this.group.scrollType === 'recent') {
                  if (this.scrollbar.scrollbarCurrentPositionX() < 100) {
                    this.scrollbar.scrollToBottom();
                  } else {
                    this.scrollbar.checkParams();
                  }
                }
              });
            }, 50);
            this.cdr.detectChanges();
          });

          setTimeout(() => {
            this.loading = false;
            this.cdr.markForCheck();
          }, 40);

          this.isGroupSelected = true;
          if (this.isChatOpened) {
            this.scrollToUnreadMsg();
            this.keyboardModalComponent.form.enable();
          }
          resolve();
        }).catch((error) => {
          this.appService.showAlert('Error', error.toString(), true);

          reject();
        });

      }
    });
  }

  ngOnDestroy() {
    this.group.unSelect();
    this._chatGroupChangedSub?.unsubscribe();
    // this._groupChangedSub?.unsubscribe();

    this.hide();
  }

  scrollToBottom() {
    this.scrollbar.scrollToBottom();
  }

  loadMoreUp() {
    this.group.loadMoreUp().then(() => {
      this.cdr.detectChanges();
    });
  }

  loadMoreDown() {
    this.group.loadMoreDown().then(() => {
      this.cdr.detectChanges();
    });
  }

  scrollToUnreadMsg() {
    setTimeout(() => {
      if (this.group?.dynamicData?.firstUnreadMessageId) {
        this.scrollbar.scrollToMessage(this.group.dynamicData.firstUnreadMessageId);
        this.observer.forEach(item=> {
          item.initObserver();
        });
      }
      this.scrollbarOnStart = true;
      this.cdr.detectChanges();
    }, 50);
  }

  visibleMessage(message: Message) {
    // console.log(message);
    message.read();
  }

  async show() {
    this.chatHeight.checkSize();
    // this.modalTabsItem.updateHeight(0);
    this.showFixedChatInput = true;
    this.isChatOpened = true;
    if (this.isGroupSelected) {
      this.scrollToUnreadMsg();
    }
    // this.chatService.openChat$.next();
    this.keyboardModal = await this.appService.appModalService.openKeyboardModal(async (content) => {
      if (!this.group) {
        this.getRandomString();
        this.groupCreateState = true;
        this.keyboardModalComponent.form.disable();
        this.cdr.markForCheck();
        // console.log('createGroup');
        await this.createGroup();

        // console.log('findGroup');
        this.findGroup();

        // console.log('selectGroup');
        await this.selectGroup();
        this.groupCreateState = false;
        this.keyboardModalComponent.form.enable();
        this.cdr.markForCheck();
      }

      // console.log('sendMessage');
      await this.group.sendMessage(content);
      if (this.group.scrollType === 'recent') {
        this.scrollbar.scrollToBottom();
      }


    }, (chatInput) => {
      // sorry, but did not find way to get instance of modal controller in another way
      this.keyboardModalComponent = chatInput;
      if (this.isGroupSelected) {
        this.keyboardModalComponent.form.enable();
      }
    });
  }

  hide() {
    this.showFixedChatInput = false;
    this.appService.appModalService.closeKeyboardModal();
  }

  getRandomString() {
    const map = [
      'Находим виноватых',
      'Собираем людей',
      'Звоним начальнику',
      'Ушла на обед',
      'Ждите очереди'
    ];

    this.loadingString = map[HelperService.random(0, (map.length - 1))];
  }

}
